// extracted by mini-css-extract-plugin
export default {"melodyVideo":"TL-z","isFullWidth":"UL-z","landingPageVideo":"VL-z","play":"WL-z","iframeVideo":"XL-z","playHidden":"YL-z","fullwidth":"ZL-z"};